import * as React from "react";
import {Button} from "reactstrap";
import {Link} from "react-router-dom";
import {Fragment} from "react";
import "./../views/Authenticated/Beneficiaries/beneficiaries.css";

export default class ButtonAddNewComponent extends React.Component {

    constructor(props) {
        super(props);

        this.className = this.props.className;

        this.state = {
            selected: false
        };
    }

    extend() {
        this.setState({
            selected: !this.state.selected
        })
    }

    render() {
        return <Fragment>

            {this.props.transactionNew ? this.renderTransactionNew(this.className) : this.renderNew(this.className)}

        </Fragment>
    }

    renderTransactionNew(className) {

        return <Fragment>

            <div>
                {this.state.selected && <div>
                    <Link to={"/beneficiaries-existing"}>
                        <Button className={className + "_add_new_button_existing_beneficiary"}>Existing Beneficiary</Button>
                    </Link>
                    <Link to={"/create-transaction"}>
                        <Button className={className + "_add_new_button_new_beneficiary"}>New Beneficiary</Button>
                    </Link>
                </div>
                }
                <Button className={className + "_add_new_button"} onClick={this.extend.bind(this)}>
                    <div className={"fa fa-plus " + className + "_add_new_button_plus"}/>
                </Button>
            </div>

        </Fragment>

    }

    renderNew(className) {

        return <Link to={this.props.link}>
            <div>
                <Button style={{boxShadow: "0px 0px 1px black"}} className={className + "_add_new_button"}>
                    <div className={"fa fa-plus " + className + "_add_new_button_plus"}/>
                </Button>
            </div>
        </Link>

    }
}